export default "__VITE_ASSET__Lxb01NLy__"